import { useEffect, useState, useContext } from 'react';
// import ImageUndergraduate from '../../../../styles/images/undergraduate-visual.svg';
import SessionContext from '../../../../library/Core/SessionContext';
import {SmartContext} from '../../../../library/Core/SmartContext';
import CurrentJobInformationRightPanel from '../CurrentJobInformationRightPanel';
import { getDomainValueForCode, getFlexColDomainValueForCode } from '../../../../library/Core/SmartFunctions';
import { getUniversityImage } from '../../../../common/styles/Images';
let SchoolLogo = sessionStorage.getItem('school-image') as any;

const ImageUndergraduate = `${process.env.REACT_APP_IMAGE_BASEPATH}/undergraduate-visual.svg`;

const UGHigherStudiesLayout = (props: any) => {    
    const { sessionState } = useContext(SessionContext);
    const userStatusCode = sessionState?.userStatusCode;
    const userTypeCode = sessionState?.userTypeCode;
    const profileStatusCode = sessionState?.profileStatusCode; 
    const isInternalHeaderActive = userTypeCode != 'SUPER_ADMIN' && userTypeCode != 'INSTITUTE_ADMIN' && userStatusCode != 'ACTIVE' && profileStatusCode != 'basic-info-complete' && profileStatusCode != 'COMPLETE'
    const { state, dispatch } = useContext(SmartContext);
    
    const userData = state.data?.user;

    const getCurrentStatus = () => {
        let currentStatus = '';
        if (state?.data?.profile?.presentEducationStatusCode === 'PURSUING_STUDIES') {
            currentStatus = `Pursuing ${state?.data?.profile?.pursuingEducationLevelCode}`;
        } else {
            currentStatus = `Completed ${state?.data?.profile?.highestCompletedEducationLevelCode}`;
        }

        return currentStatus;
    };

    const underGradCollegeJoined = state?.data?.underGradCollegeJoined || [];
    const flexDataJson = getFlexColDomainValueForCode(underGradCollegeJoined?.universityId, 'INSTITUTE_DOMAIN', state);
    const flexData = flexDataJson ? JSON.parse(flexDataJson) : null;
    
    const previewCardData = {
        "currentStatus": getCurrentStatus(),
        "entityHeading": underGradCollegeJoined?.universityId > 0 ? getDomainValueForCode(underGradCollegeJoined?.universityId, 'INSTITUTE_DOMAIN', state) : underGradCollegeJoined?.otherUniversity,
        "entityLogo": getUniversityImage(flexData?.logo),
        "entitySubHeading": underGradCollegeJoined?.fieldOfStudyCode > 0 ? getDomainValueForCode(underGradCollegeJoined?.fieldOfStudyCode, 'FIELD_OF_STUDY_TYPE_CODE', state) : underGradCollegeJoined?.otherFieldOfStudyCode,      
    };

    //const [userStatusCode, setUserStatusCode] = useState(sessionStorage.getItem('user-status-code'));
    // useEffect(() => {
    //     setUserStatusCode(sessionStorage.getItem('user-status-code'));
    // }, []);
    return (
        <div className="main-wrap">
            <div className="leftPane">
                <div className="leftPaneWrap">
                    {isInternalHeaderActive && (
                        <div className="leftPaneHeaderWrap">
                            <div className="leftPaneHeader">
                                <img src={SchoolLogo} alt="" className="school_logo" />

                                <label className="user_name">
                                    Hey{' '}
                                    <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                                </label>
                            </div>
                        </div>
                    )}
                    <div className="leftPaneBodyWrap">
                        <div className="leftPaneBody">
                            <div className="qs_body aos-init aos-animate" data-aos="fade-right" data-nextpage="scholarship-details.html">
                                <h2 className="mb-1">Almost There!</h2>
                                <p className="font-18">Just 2 more steps to unlock Lifetime benefits!</p>
                                <hr className="opacity-25"></hr>
                               
                                <div className="steps_questions">{props.children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rightPane basic-information undergraduate-college">
                <div className="rightPaneWrap">
                    {isInternalHeaderActive && (
                        <div className="rightPaneHeaderWrap">
                            <div className="rightPaneHeader">
                                <label className="user_name">
                                    Hey <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                                </label>
                            </div>
                        </div>
                    )}
                    {/* right panel */}
                       <CurrentJobInformationRightPanel data={previewCardData}/>
                   {/* end of right panel */}
                </div>
            </div>
            <a data-bs-toggle="collapse" data-bs-target="#listed_points" href="" className="bg-drop" aria-expanded="false"></a>
        </div>
    );
};

export default UGHigherStudiesLayout;
